import { createStore } from 'vuex'

export const dataAfastamento = createStore({
  state: () => {
    return {
      type: undefined,
      registeredTime: undefined,
      obs: undefined,
      hospital: undefined,

      user: localStorage.getItem('__user_name'),
      user_id: localStorage.getItem('__uuid'),

      realizado_em: undefined,
      expired_at: undefined,

      doc: undefined,
      docName: undefined,
      docOriginalName: undefined,

      collabs: [],
    }
  },
  getters: {
    getCollabsCombo: (state) => state.collabs,
  },
  mutations: {
    reset (state) {
      state.obs = undefined
      state.type = undefined
    },
    SET_COLLABS(state, val) {
      state.collabs = val
    }
  },
  actions: {
    setCollabsCombo({ commit }, val) {
      commit('SET_COLLABS', val);
    }
  }
})
